import React from 'react';
import PropTypes from 'prop-types';

const SideBarBannersLogo = ({ bgColor = '#6D758E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6667 2.5C17.1267 2.5 17.5 2.87333 17.5 3.33333V16.6667C17.5 17.1267 17.1267 17.5 16.6667 17.5H3.33333C2.87333 17.5 2.5 17.1267 2.5 16.6667V3.33333C2.5 2.87333 2.87333 2.5 3.33333 2.5H16.6667ZM9.32417 10.965L4.16667 11.875V15.8333H10.1817L9.32333 10.965H9.32417ZM15.8333 4.16667H9.8175L11.8742 15.8333H15.8333V4.16667ZM8.125 4.16667H4.16667V10.1817L9.035 9.32333L8.125 4.16667Z"
        fill={bgColor}
      />
    </svg>
  );
};

SideBarBannersLogo.propTypes = {
  bgColor: PropTypes.string,
};

export default SideBarBannersLogo;